import script from "./GenerateResultPreviewPopUp.vue?vue&type=script&setup=true&lang=js"
export * from "./GenerateResultPreviewPopUp.vue?vue&type=script&setup=true&lang=js"

import "./GenerateResultPreviewPopUp.vue?vue&type=style&index=0&id=6ff286b8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6ff286b8"]])

export default __exports__